<mat-card *ngIf="model">
  <mat-card-content>
    {{model | json}}
  </mat-card-content>
</mat-card>